import flex from "../../../../../styles/flex";
import React, { Fragment, } from "react";
import { AssetLocationTypes, LaneAllocationRule } from "../../../../../logic/api";
import propTypes from "prop-types";
import TextInputField from "../../../../../components/editable/EditableField/fields/TextInputField";
import LaneAllocationLocationPicker from "./LaneAllocationLocationPicker";
import { useTranslation } from "react-i18next";

export const LaneAllocationRuleProducts: React.FunctionComponent<{
    rule: LaneAllocationRule;
    onChange: (rule: LaneAllocationRule) => void;
}> = (props) => {

    const { t } = useTranslation();

    return <Fragment>
        <div style={flex.flexRows}>
            <div style={{ ...flex.flexAuto, paddingTop: 20, paddingLeft: 15 }}>{t("kmos.labels.ifBookingContains")}</div>
            <div style={{ ...flex.flexAuto, padding: 10 }}>
                <TextInputField label="Product Code" value={props.rule.productCode} onChange={(val) => {
                    props.rule.productCode = val;
                    props.onChange(props.rule);
                }}></TextInputField>
            </div>
            <div style={{ ...flex.flexAuto, paddingTop: 20 }}>{t("kmos.labels.allocateVehicleTo")}</div>
            <div style={{ ...flex.flexAuto, padding: 10 }}>
                <LaneAllocationLocationPicker
                    value={props.rule.location == null ? "" : JSON.stringify(props.rule.location)} displayTypes={[AssetLocationTypes.Zone, AssetLocationTypes.Lane]} selectionTypes={[AssetLocationTypes.Zone, AssetLocationTypes.Lane]}
                    onChange={(location) => {
                        props.rule.location = JSON.parse(location);
                        props.onChange(props.rule);
                    }}></LaneAllocationLocationPicker>
            </div>

            <div style={flex.flexFill}></div>
        </div>
    </Fragment>

        ;
}
LaneAllocationRuleProducts.propTypes = {
    rule: propTypes.any.isRequired,
    onChange: propTypes.func.isRequired,

}